export const MENU_VISIBLE = 'MENU_VISIBLE';
export const HOME_PAGE_SIMPLE_VIEW = 'HOME_PAGE_SIMPLE_VIEW';
export const SETTINGS_SPE_LIST = 'SETTINGS_SPE_LIST';

export const SETTING_SPE_UPDATE = 'SETTING_SPE_UPDATE';